import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SubscriptionLimitBanner = ({ 
  currentCount = 0, 
  maxCount = 1, 
  subscriptionTier = 'free',
  type = 'property'
}) => {
  const navigate = useNavigate();
  const isAtLimit = currentCount >= maxCount;
  const isNearLimit = currentCount >= maxCount - 1;

  if (subscriptionTier !== 'free') {
    return null;
  }

  const handleUpgrade = () => {
    navigate('/billing-dashboard');
  };

  if (isAtLimit) {
    return (
      <div className="bg-warning/10 border border-warning/20 rounded-lg p-4 md:p-6">
        <div className="flex flex-col md:flex-row md:items-center gap-4">
          <div className="flex items-start gap-3 flex-1">
            <div className="w-10 h-10 rounded-lg bg-warning/20 flex items-center justify-center flex-shrink-0">
              <Icon name="AlertTriangle" size={20} className="text-warning" />
            </div>
            <div>
              <h4 className="text-base md:text-lg font-semibold text-foreground mb-1">
                {type === 'property' ? 'Property' : 'Offer'} Limit Reached
              </h4>
              <p className="text-sm text-muted-foreground">
                You've reached the maximum of {maxCount} {type === 'property' ? 'property' : 'offers'} on the Free plan. 
                Upgrade to Pro for unlimited {type === 'property' ? 'properties' : 'offers'} and AI-powered features.
              </p>
              <p className="text-xs text-muted-foreground mt-2">
                Pro plans start at just $15/month or save with $150/year.
              </p>
            </div>
          </div>
          <Button
            variant="default"
            onClick={handleUpgrade}
            iconName="ArrowUpRight"
            iconPosition="right"
            className="w-full md:w-auto"
          >
            Upgrade to Pro
          </Button>
        </div>
      </div>
    );
  }

  if (isNearLimit) {
    return (
      <div className="bg-accent/10 border border-accent/20 rounded-lg p-4 md:p-6">
        <div className="flex flex-col md:flex-row md:items-center gap-4">
          <div className="flex items-start gap-3 flex-1">
            <div className="w-10 h-10 rounded-lg bg-accent/20 flex items-center justify-center flex-shrink-0">
              <Icon name="Info" size={20} className="text-accent" />
            </div>
            <div>
              <h4 className="text-base md:text-lg font-semibold text-foreground mb-1">
                Almost at Your Limit
              </h4>
              <p className="text-sm text-muted-foreground">
                You're using {currentCount} of {maxCount} {type === 'property' ? 'properties' : 'offers'} on the Free plan. 
                Upgrade to Pro for unlimited access and advanced features.
              </p>
              <p className="text-xs text-muted-foreground mt-2">
                Pro plans start at just $15/month or save with $150/year.
              </p>
            </div>
          </div>
          <Button
            variant="outline"
            onClick={handleUpgrade}
            iconName="Crown"
            iconPosition="left"
            className="w-full md:w-auto"
          >
            View Plans
          </Button>
        </div>
      </div>
    );
  }

  return null;
};

export default SubscriptionLimitBanner;